import Script from 'next/script';

const Genesys = () => (
  <Script
    strategy='afterInteractive'
    type='text/javascript'
    src='/webmessenger/genesys-webmessenger.js'
  />
);

export default Genesys;
